import React, { useState } from 'react';
import MaterialTable from 'material-table';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import { api } from 'common';
import { downloadCsv } from '../../common/sharedFunctions';
import localization from '../Table/Localization';
import {
  C2,
  C2_FONT,
  c2TableOptions,
  c2TableStyle,
  c2Toolbar,
  c2Localization,
  C2TableCard,
  C2SectionHeading,
  C2EmptyState,
} from '../Table/C2UserTable';

export const formatCop = (v) => api.formatCop(Math.round(Number(v) || 0));

const csvCell = (v) => {
  const s = v == null ? '' : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

/** Celda de dos líneas: valor principal y detalle en gris. */
export function C2Cell({ primary, secondary, color, strong = true }) {
  return (
    <Box sx={{ textAlign: 'left' }}>
      <Typography sx={{ fontFamily: C2_FONT, fontWeight: strong ? 700 : 500, fontSize: '0.88rem', color: color || C2.sidebar, whiteSpace: 'nowrap' }}>
        {primary}
      </Typography>
      {secondary ? (
        <Typography sx={{ fontFamily: C2_FONT, fontSize: '0.75rem', color: C2.muted }}>{secondary}</Typography>
      ) : null}
    </Box>
  );
}

/** Opciones de mes a partir de las filas (orden descendente). */
export const monthOptions = (rows, { allLabel } = {}) => {
  const keys = [...new Set((rows || []).map((r) => r.monthKey).filter(Boolean))].sort((a, b) => b.localeCompare(a));
  const opts = keys.map((k) => ({ value: k, label: api.reportMonthLabel(k) }));
  return allLabel ? [{ value: '', label: allLabel }, ...opts] : opts;
};

export default function C2ReportTable({
  title,
  subtitle,
  columns,
  data,
  loading,
  emptyIcon = AssessmentOutlinedIcon,
  emptyTitle,
  emptyMessage,
  csvFileName,
  toolbarExtras = [],
  actions,
  canExport = true,
  children,
}) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const [selectedRow, setSelectedRow] = useState(null);

  const exportCsv = (cols, rows) => {
    const header = cols.map((c) => (typeof c.title === 'string' ? c.title : c.field));
    const body = rows.map(({ tableData, ...row }) =>
      cols.map((c) => (c.exportTransformer ? c.exportTransformer(row) : row[c.field]))
    );
    downloadCsv([header, ...body].map((r) => r.map(csvCell).join(',')).join('\n'), csvFileName);
  };

  return (
    <C2TableCard>
      <C2SectionHeading title={title} subtitle={subtitle} />
      {children}
      <MaterialTable
        title={title}
        columns={columns}
        data={data || []}
        isLoading={loading}
        style={c2TableStyle(isRTL)}
        components={c2Toolbar(...toolbarExtras)}
        onRowClick={(evt, row) => setSelectedRow(row.tableData.id)}
        actions={actions}
        options={{
          ...c2TableOptions(selectedRow),
          pageSize: 10,
          pageSizeOptions: [10, 25, 50],
          actionsColumnIndex: -1,
          exportButton: canExport ? { csv: true, pdf: false } : false,
          exportAllData: true,
          exportCsv,
        }}
        localization={c2Localization(localization(t), <C2EmptyState icon={emptyIcon} title={emptyTitle} message={emptyMessage} />)}
      />
    </C2TableCard>
  );
}
